export default __webpack_public_path__ + "static/media/birthday.59a652d9.svg";